import { useQuery} from '@tanstack/react-query'
import api from '../api';
import React, { useState, useEffect, useRef } from 'react';
import Skill from "./Skill";
import AddCustomSkill from "./AddCustomSkill";
import Lottie from 'react-lottie-player';
import loadingAnimation from '../animations/loading.json';
import Loader from './Loader';

export default function Skills({randomId, storedData, jobTitle, jobDescription, setStoredData, setStep}) {
    const [isLoading, setIsLoading] = useState(false);
    const loadRef = useRef();
    const [hardSkills, setHardSkills] = useState([]);
    const [softSkills, setSoftSkills] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const [selectedHardSkills, setSelectedHardSkills] = useState([]);
    const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);
    const [allHardSelected, setAllHardSelected] = useState(false);
    const [allSoftSelected, setAllSoftSelected] = useState(false);

    const { isError, refetch } = useQuery(
		['getSkills'], 
		() => api.getSkills(jobTitle, jobDescription), 
        {
            enabled: false,
            onSuccess: data => {
                console.log(data);
                const soft = JSON.parse(data.soft).map((skill, index) => {
                   return {
                        id: Math.floor(Math.random() * 100000),
                        text: skill,
                        type: "soft",
                    }
                    
                });
                const hard = JSON.parse(data.hard).map((skill, index) => {
                    return {
                        id: Math.floor(Math.random() * 100000),
                        text: skill,
                        type: "hard",
                    }
                });
                setSoftSkills(soft);
                setHardSkills(hard);
                const d = {...storedData};
                d.soft = soft;
                d.hard = hard;
                localStorage.setItem(randomId, JSON.stringify(d));
                setStoredData(d);
               setIsLoading(false);
            },
        }
	)

    useEffect(() => {
        if(!jobTitle){
            return;
        }
        if(storedData?.soft?.length === 0){
            setIsLoading(true);
            refetch();
        }else{
            const soft = storedData.soft.map((skill, index) => {
                return {
                    id: Math.floor(Math.random() * 100000),
                    text: skill.text,
                    type: "soft",
                }
                
            });
            const hard = storedData.hard.map((skill, index) => {
                return {
                    id: Math.floor(Math.random() * 100000),
                    text: skill.text,
                    type: "hard",
                }
            });
            setSoftSkills(soft);
            setHardSkills(hard);
        }
    }, [jobTitle])


    const addSkill = (skill) =>{
        if(skill.type === "hard"){
            setSelectedHardSkills(prevSkills => [...prevSkills, skill]);
        }else{
            setSelectedSoftSkills(prevSkills => [...prevSkills, skill]);
        }
    }
    const removeSkill = (skill) =>{
        if(skill.type === "hard"){
            setSelectedHardSkills(prevSkills => prevSkills.filter(( item, i) => item.id !== skill.id));
        }else{
            setSelectedSoftSkills(prevSkills => prevSkills.filter(( item, i) => item.id !== skill.id));
        }
    }
    const addCustomSkill = (type, text) => {
        const skill = {
            id: Math.floor(Math.random() * 100000),
            text: text,
            type: type
        }
        if(type === "hard"){
            setHardSkills([
                ...hardSkills, ...[skill]
            ])
        }else{
            setSoftSkills([
                ...softSkills, ...[skill]
            ])
        }
    }
    function generateQuestions(e){
        e.preventDefault();
        const d = { ...storedData };
        d.selectedSoftSkills = selectedSoftSkills.map((skill) => skill.text);
        d.selectedHardSkills = selectedHardSkills.map((skill) => skill.text);
        localStorage.setItem(randomId, JSON.stringify(d));
        setStoredData(d);
        setStep('questions');
    }
    useEffect(() => {
        isLoading === false && setSpinner(!spinner)
    }, [isLoading]);
    useEffect(() => {
        if (loadRef.current){
            const d = { ...storedData };
            d.softQuestions = [];
            d.hardQuestions = [];
            localStorage.setItem(randomId, JSON.stringify(d));
            setStoredData(d);
        }
        loadRef.current = true;
    }, [])
    return (
        <div className="page">
            {isLoading && 
                <div className='text__center'>
                    <Lottie
                        loop
                        animationData={loadingAnimation}
                        play
                        style={{ width: 250, height: 250, margin: 'auto' }}
                    />
                    <h3>
                        The AI is creating the best skills to test for the <h3 className="text__primary text__bold">{jobTitle}</h3> position
                    </h3>
                    <Loader />
                </div>  
            }
            { isError &&
                console.log("No Data")
            }
            {!isLoading && !isError && hardSkills.length > 1 &&
                <div className="">
                    <h4 className='text__primary'>
                        Generated Skills for: {jobTitle}
                    </h4>
                    <form method="post" className='' onSubmit={generateQuestions}>
                        <div className='card card__rounded'>
                            <div className="">
                                <div>
                                    <h4 className='text__primary'>Pick Hard Skills</h4>
                                    <div className="text__muted font__12">More skills selected means that the question generation will take a bit longer</div>
                                </div>
                                <div className="btn btn__success btn__md">
                                    {selectedHardSkills.length} selected
                                </div>
                                <div className="select__all">
                                    <div>
                                        <input
                                            type="checkbox"
                                            checked={allHardSelected}
                                            value="select all"
                                            onChange={(e) => setAllHardSelected(e.target.checked)}
                                            className='switch'
                                        />
                                        <span className="mleft--10">Select All</span>
                                    </div>
                                </div>
                            </div>
                            <hr className="mtop--10 mbottom--10"/>
                            {
                                hardSkills.map((dt, index) => (
                                    <div className="mtop--5" key={`hard_skill${index}`}>
                                        <Skill skill={dt} isChecked={allHardSelected} add={addSkill} remove={removeSkill} />
                                    </div>
                                ))
                            }
                            <AddCustomSkill type="hard" addCustomSkill={addCustomSkill} />
                        </div>
                        <div className='card card__rounded'>
                            <div>
                                <h4 className='text__primary'>Pick Soft Skills</h4>
                                <div className="text__muted font__12">More skills selected means that the question generation will take a bit longer</div>
                                <div className="btn btn__success btn__md">
                                    {selectedSoftSkills.length} selected
                                </div>
                            </div>
                            <div className="select__all">
                                <div>
                                    <input
                                        type="checkbox"
                                        checked={allSoftSelected}
                                        value="select all"
                                        onChange={(e) => setAllSoftSelected(e.target.checked)}
                                        className='switch'
                                    />
                                    <span className="mleft--10">Select All</span>
                                </div>
                            </div>
                            <hr className="mtop--10 mbottom--10" />
                            {
                                softSkills.map((dt, index) => (
                                    <div className="mtop--5" key={`soft_skill${index}`}>
                                        <Skill skill={dt} isChecked={allSoftSelected} add={addSkill} remove={removeSkill} />
                                    </div>
                                ))
                            }
                            <AddCustomSkill type="soft" addCustomSkill={addCustomSkill} />
                        </div>
                        <button className="btn btn__primary btn__100 btn__rounded">
                            Continue with <b>{selectedHardSkills.length + selectedSoftSkills.length}</b> selected skills
                        </button>
                    </form>
                </div>
            }
        </div>  
    )
}